/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BumpItem,
    BumpItemFromJSON,
    BumpItemFromJSONTyped,
    BumpItemToJSON,
    BumpMenu,
    BumpMenuFromJSON,
    BumpMenuFromJSONTyped,
    BumpMenuToJSON,
    BumpSerie,
    BumpSerieFromJSON,
    BumpSerieFromJSONTyped,
    BumpSerieToJSON,
} from './';

/**
 * 
 * @export
 * @interface Bump
 */
export interface Bump {
    /**
     * 
     * @type {Array<BumpItem>}
     * @memberof Bump
     */
    items: Array<BumpItem>;
    /**
     * 
     * @type {Array<BumpMenu>}
     * @memberof Bump
     */
    menus: Array<BumpMenu>;
    /**
     * 
     * @type {Array<BumpSerie>}
     * @memberof Bump
     */
    series: Array<BumpSerie>;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    guiUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    iconUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    readmoreContentUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    summaryContentUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof Bump
     */
    publicOutUrl: string;
}

export function BumpFromJSON(json: any): Bump {
    return BumpFromJSONTyped(json, false);
}

export function BumpFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bump {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BumpItemFromJSON)),
        'menus': ((json['menus'] as Array<any>).map(BumpMenuFromJSON)),
        'series': ((json['series'] as Array<any>).map(BumpSerieFromJSON)),
        'guiUrl': json['guiUrl'],
        'iconUrl': json['iconUrl'],
        'readmoreContentUrl': json['readmoreContentUrl'],
        'summaryContentUrl': json['summaryContentUrl'],
        'category': json['category'],
        'publicOutUrl': json['publicOutUrl'],
    };
}

export function BumpToJSON(value?: Bump | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(BumpItemToJSON)),
        'menus': ((value.menus as Array<any>).map(BumpMenuToJSON)),
        'series': ((value.series as Array<any>).map(BumpSerieToJSON)),
        'guiUrl': value.guiUrl,
        'iconUrl': value.iconUrl,
        'readmoreContentUrl': value.readmoreContentUrl,
        'summaryContentUrl': value.summaryContentUrl,
        'category': value.category,
        'publicOutUrl': value.publicOutUrl,
    };
}


